"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabBar = exports.TabBarItem = exports.TabBarDefaultProps = exports.TabBarItemDefaultProps = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TabBarItemDefaultProps = {
  classNames: '',
  disabled: false,
  selected: false
};
exports.TabBarItemDefaultProps = TabBarItemDefaultProps;
var TabBarDefaultProps = {
  classNames: '',
  disabled: false,
  size: 'large'
};
exports.TabBarDefaultProps = TabBarDefaultProps;

var TabBarItem = function TabBarItem(props) {
  var classNames = props.classNames,
      disabled = props.disabled,
      selected = props.selected,
      onClick = props.onClick,
      children = props.children,
      NewProps = _objectWithoutProperties(props, ["classNames", "disabled", "selected", "onClick", "children"]);

  var tabBarItemClassName = (0, _classnames.default)({
    'tabbar-component__tabbaritem-component': true,
    'tabbar-component__tabbaritem-component__selected': selected,
    'tabbar-component__tabbaritem-component__disabled': disabled,
    'tabbar-component__tabbaritem-component__clickable': !disabled && onClick
  }, classNames); // If not disabled allow tabs to be 'focus'able for ADA compliance

  if (!disabled) {
    // @ts-ignore
    NewProps.tabIndex = 0;
  } // ADA compliant - allow an enter key to act like a click.


  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, NewProps, {
    className: tabBarItemClassName,
    onClick: onClick,
    role: "button",
    tabIndex: 0,
    onKeyDown: _handleKeyPress
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: 'tabbar-component__tabbaritem-component__label'
  }, children));
};

exports.TabBarItem = TabBarItem;
TabBarItem.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  selected: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func,
  children: _propTypes.default.node
};
TabBarItem.defaultProps = TabBarItemDefaultProps;

var TabBar = function TabBar(props) {
  var _classNamesFn;

  var classNames = props.classNames,
      disabled = props.disabled,
      children = props.children,
      onClick = props.onClick,
      size = props.size,
      NewProps = _objectWithoutProperties(props, ["classNames", "disabled", "children", "onClick", "size"]);

  var tabBarClassName = (0, _classnames.default)((_classNamesFn = {
    'tabbar-component': true
  }, _defineProperty(_classNamesFn, "tabbar-component__".concat(size), true), _defineProperty(_classNamesFn, 'tabbar-component__disabled', disabled), _classNamesFn), classNames); // Combine the properties passed to the parent with the child elements.
  // Processing react children is a little weird, see https://reactjs.org/docs/react-api.html#reactchildren for details.

  var countValidChildren = 0;

  var renderWrappedChildren = _react.default.Children.map(children, function (child) {
    if (child.type === TabBarItem) {
      countValidChildren += 1;
      return _react.default.cloneElement(child, {
        disabled: disabled || child.props.disabled,
        onClick: child.props.onClick || onClick
      });
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }); // No children then output nothing.


  if (_react.default.Children.count(children) === 0 || countValidChildren === 0) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }

  return /*#__PURE__*/_react.default.createElement("div", _extends({}, NewProps, {
    className: tabBarClassName
  }), renderWrappedChildren);
};

exports.TabBar = TabBar;
TabBar.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  size: _propTypes.default.oneOf(['large', 'small']).isRequired,
  onClick: _propTypes.default.func,
  children: _propTypes.default.node
};
TabBar.defaultProps = TabBarDefaultProps;
var _default = TabBar;
exports.default = _default;